import { selectBaseCustomerPricesV814 } from './modelPresentationV814';
import { selectAvailableSourceQuotesV107 } from '../CommercialV106/PriceOfferSelectorV106';
import {
  isMediaPriceV111,
  mediaPriceLabelV111,
  selectMediaCardPricesV111,
} from './mediaPricePresentationV111';

const input = ['input_tokens', 'input_text_tokens'];
const output = ['output_tokens', 'output_text_tokens'];
const priorities = {
  language: [['scrape_pages'], ['search_requests'], ['search_first_result'], ['search_additional_results'], ['media_units'], input, output, ['cached_input_tokens']],
  image: [
    ['media_units'],
    input,
    ['image_output_tokens'],
    ['image'],
    output,
    ['cached_input_tokens'],
  ],
  video: [['media_units'], ['video_duration'], ['video'], input, output],
  audio: [
    ['media_units'],
    ['audio_duration'],
    ['audio_characters'],
    ['input_audio_tokens'],
    ['output_audio_tokens'],
    input,
    output,
  ],
};

export const selectCardPricesV108 = (prices = [], categories = []) => {
  const all = Array.isArray(prices) ? prices : [];
  if (all.some(isMediaPriceV111)) return selectMediaCardPricesV111(all);
  const summary = selectBaseCustomerPricesV814(all);
  const mode =
    ['video', 'image', 'audio'].find((category) =>
      categories.includes(category)
    ) || 'language';
  return priorities[mode]
    .flatMap((meters) => {
      const price = meters
        .map((meter) => summary.find((item) => item.meter === meter))
        .find(Boolean);
      if (!price) return [];
      const variants = all.filter(
        (item) => item.meter === price.meter && item.unit === price.unit
      );
      const attributes = price.attributes || {};
      const scoped = Object.entries(attributes).some(
        ([key, value]) =>
          ![
            'context_min_tokens',
            'context_max_tokens',
            'service_tier',
            'fallback_only',
          ].includes(key) &&
          value !== '' &&
          value != null
      );
      const amount = Number(price.unit_amount_usd);
      const minimum =
        Number.isFinite(amount) &&
        variants.every((item) => Number(item.unit_amount_usd) >= amount);
      return [
        {
          ...price,
          from:
            minimum &&
            (scoped ||
              variants.some((item) => Number(item.unit_amount_usd) !== amount)),
        },
      ];
    })
    .slice(0, 4);
};

const meterLabels = {
  input_tokens: 'input',
  input_text_tokens: 'input',
  output_tokens: 'output',
  output_text_tokens: 'output',
  cached_input_tokens: 'cache_hit',
  image: 'image',
  image_output_tokens: 'image',
  video: 'video',
  video_duration: 'video',
  audio_characters: 'audio',
  audio_duration: 'audio',
  input_audio_tokens: 'audio_input',
  output_audio_tokens: 'audio_output',
  media_units: 'output',
  search_requests: 'search',
};

export const priceSummaryLabelV108 = (price, t) => {
  if (isMediaPriceV111(price)) return mediaPriceLabelV111(price, t);
  if (['scrape_pages', 'search_first_result', 'search_additional_results'].includes(price?.meter)) {
    return t(`models.commercial.meters.${price.meter}`);
  }
  const key = meterLabels[price?.meter] || 'output';
  return t(`models.catalog_v10.price_summary.${key}`, {
    defaultValue: key,
  });
};

export const catalogPriceOptionsV108 = (presentation, baseName) => {
  const sources = selectAvailableSourceQuotesV107(presentation?.sourceQuotes);
  if (sources.length) return sources;
  if (presentation?.sourceDirectoryV107) return [];
  const offers = (presentation?.offers || []).filter(
    (offer) =>
      Array.isArray(offer.customer_prices) && offer.customer_prices.length
  );
  if (offers.length) {
    return selectAvailableSourceQuotesV107(
      offers.map((offer) => ({
        ...offer,
        kind: 'sales_tier',
        pricing_mode: 'reference',
        billable: false,
      }))
    );
  }
  const prices = presentation?.prices || [];
  return prices.length
    ? [
        {
          id: 'catalog-base-price',
          name: baseName,
          kind: 'base_price',
          multiplier: '1',
          effective_multiplier: '1',
          customer_prices: prices,
          pricing_mode: 'reference',
          billable: false,
        },
      ]
    : [];
};
